import { Pipe, PipeTransform } from '@angular/core';
import { formatNumber } from '@angular/common';
import { curryRight } from 'lodash-es';
import {
  abbreviateNumber,
  Formatter,
  nfCurrencyTransform,
} from '@aptitude/shared-vanilla';

type TierFieldNames =
  | 'dollarMarketShare'
  | 'unitMarketShare'
  | 'absoluteDollars'
  | 'absoluteUnits';

@Pipe({
    name: 'formatPlannedSpendLevel',
    standalone: false
})
export class FormatPlannedSpendLevelPipe implements PipeTransform {
  static curried() {
    return curryRight(formatNumber, 2)('en-US') as any;
  }

  transform(
    value: number | null,
    type: TierFieldNames,
    truncateValue: boolean,
    placeHolderValue?: string,
  ): string {
    return transform(
      value,
      type,
      truncateValue,
      Formatter.currency,
      Formatter.percent,
      FormatPlannedSpendLevelPipe.curried(),
      placeHolderValue,
    );
  }
}

function transform(
  value: number | null,
  type: string,
  truncateValue = false,
  formatMoney: (arg1: number | null) => string,
  formatPercent: (arg1: number | null) => string,
  formatNumberInner: (arg1: number | null) => string,
  placeHolderValue = 'N/A',
): string {
  let formattedValue = '';

  if (value === null) {
    return placeHolderValue;
  }

  switch (type) {
    case 'unitMarketShare':
    case 'dollarMarketShare':
      formattedValue = formatPercent(value);
      break;
    case 'absoluteUnits':
      // use abbreviated format if truncateValue = true
      formattedValue = truncateValue
        ? abbreviateNumber(value)
        : formatNumberInner(value);
      break;
    case 'absoluteDollars':
      // use abbreviated format if truncateValue = true
      formattedValue = truncateValue
        ? '$' + abbreviateNumber(value)
        : nfCurrencyTransform(value, formatMoney);
      break;
    default:
  }

  return formattedValue;
}
